//修改自：https://github.com/janogonzalez/priorityqueuejs

module.exports = PriorityQueue;

function PriorityQueue(d) {
    this._d = d;
    this._elements = [];
}

PriorityQueue.prototype.checkEdgeCrossing = function(P1,P2,Q1,Q2){
    if(Math.min(P1.x,P2.x) <= Math.max(Q1.x,Q2.x) &&
        Math.min(Q1.x,Q2.x) <= Math.max(P1.x,P2.x) &&
        Math.min(P1.y,P2.y) <= Math.max(Q1.y,Q2.y) &&
        Math.min(Q1.y,Q2.y) <= Math.max(P1.y,P2.y)){
        if(
            ((Q1.x-P1.x)*(Q1.y-Q2.y)-(Q1.y-P1.y)*( Q1.x-Q2.x)) * ((Q1.x-P2.x)*(Q1.y-Q2.y)-(Q1.y-P2.y)*(Q1.x-Q2.x)) < 0 &&
            ((P1.x-Q1.x)*(P1.y-P2.y)-(P1.y-Q1.y)*(P1.x-P2.x)) * ((P1.x-Q2.x)*(P1.y-P2.y)-(P1.y-Q2.y)*( P1.x-P2.x)) < 0
        ){
            return true;
        }
        else{
            return false;
        }
    }
    else{
        return false
    }
}

PriorityQueue.prototype.isEmpty = function() {
    return this.size() === 0;
};

PriorityQueue.prototype.peek = function() {
    if (this.isEmpty()) throw new Error('PriorityQueue is empty');
    return this._elements[0];
};

PriorityQueue.prototype.modify_Prim = function(e1,e2,thisid,weightcross){
    //let a = this._elements.length
    //console.log("modify before: " + a)
    let szbefore = this._elements.length;
    for(let i = this._elements.length - 1;i >= 0;i --){
        let s = this._d[this._elements[i]].start;
        let e = this._d[this._elements[i]].end;
        let id = this._d[this._elements[i]].clusterid2;
        if((!this._d.hasOwnProperty(this._elements[i])) || id == thisid){
            this._elements.splice(i,1);
            continue;
        }
        if(this.checkEdgeCrossing(s,e,e1,e2) && s.cat != e1.cat && e.cat != e2.cat){
            this._d[this._elements[i]].score += weightcross
        }
    }
    let tmp = this._elements;
    this._elements = [];
    for(let i = 0;i< tmp.length;i++){
        this.enq(tmp[i]);
    }

    let sz = this._elements.length;
    if(sz <= 1 || sz == szbefore){
        return;
    }
    for(let i = parseInt((sz - 2) / 2);i >= 0;i --){
        this.adjust(i,sz - 1);
    }

}

PriorityQueue.prototype.searchFather = function (f,x){
    while(x!=f[x]){
        f[x] = f[f[x]];
        x = f[x];
    }
    return x;
}

PriorityQueue.prototype.adjust = function(start, m){
    let i = start;
    let j = 2 * i + 1;
    let tmp = this._elements[i];
    while(j <= m){
        if(j < m && this._compare(j, j + 1)){
            j ++;
        }
        if(this._d[tmp].score <= this._d[this._elements[j]].score){
            break;
        }
        else{
            this._elements[i] = this._elements[j];
            //V1
            //this._d[this._elements[i]].pid = i;
            i = j;
            j = 2 * j + 1;
        }
    }
    this._elements[i] = tmp;
    //V1
    //this._d[this._elements[i]].pid = i;
}
//function(e1,e2,f,weightcross,fa)

PriorityQueue.prototype.modify_Kruskal_V2 = function(e1,e2,f,weightcross){

    //let szbefore = this._elements.length;
    let tmp = []
    for(let i = this._elements.length - 1;i >= 0;i --){
        let s = this._d[this._elements[i]].start;
        let e = this._d[this._elements[i]].end;
        let fs = this.searchFather(f,this._d[this._elements[i]].clusterid1);
        let fe = this.searchFather(f,this._d[this._elements[i]].clusterid2);
        if((!this._d.hasOwnProperty(this._elements[i]))){
            this._elements.splice(i,1);
            continue;
        }
        if(fs == fe){
            delete this._d[this._elements[i]];
            this._elements.splice(i,1);
            continue;
        }
        if(this.checkEdgeCrossing(s,e,e1,e2) && s.cat != e1.cat && e.cat != e2.cat){
            this._d[this._elements[i]].score += weightcross
        }
        tmp.push(this._elements[i])
    }

    let sz = tmp.length;

    if(sz <= 1){
        return;
    }

    this._elements=[]

    for(let i = 0;i < sz;i ++){
        this.enq(tmp[i]);
    }

    //for(let i = parseInt((sz - 2) / 2);i >= 0;i --){
    //    this.adjust(i,sz - 1);
    //}

}

PriorityQueue.prototype.modify_Kruskal = function(e1,e2,f,weightcross,fa){
    //let a = this._elements.length
    //console.log("modify before: " + a)
    //let szbefore = this._elements.length;
    //for(let i = this._elements.length - 1;i >= 0;i --){
    //    let s = this._d[this._elements[i]].start;
    //    let e = this._d[this._elements[i]].end;
    //    let fs = this.searchFather(f,this._d[this._elements[i]].clusterid1);
    //    let fe = this.searchFather(f,this._d[this._elements[i]].clusterid2);
    //    if((!this._d.hasOwnProperty(this._elements[i]))){
    //        this._elements.splice(i,1);
    //        continue;
    //    }
    //    if(fs == fa && fe == fa){
    //        delete this._d[this._elements[i]];
    //        this._elements.splice(i,1);
    //        continue;
    //    }
    //    if(this.checkEdgeCrossing(s,e,e1,e2) && s.cat != e1.cat && e.cat != e2.cat){
    //        this._d[this._elements[i]].score += weightcross
    //    }
    //}

    let sz = this._elements.length;

    //if(sz <= 1 || sz == szbefore){
    //    return;
    //}

    for(let i = parseInt((sz - 2) / 2);i >= 0;i --){
        this.adjust(i,sz - 1);
    }

    //for(let i = 0;i < sz;i ++){
    //    this._d[this._elements[i]].pid = i;
    //}

}

PriorityQueue.prototype.deq = function() {
    //let a = this._elements.length
    //console.log("deq before: " + a)
    //delete this._d[this._elements[0]];
    var first = this.peek();
    //V1
    //this._d[first].pid = -1;
    var last = this._elements.pop();
    var size = this.size();
    if (size === 0) return first;

    this._elements[0] = last;
    var current = 0;

    while (current < size) {
        var largest = current;
        var left = (2 * current) + 1;
        var right = (2 * current) + 2;

        if (left < size && this._compare(left, largest) >= 0) {
            largest = left;
        }

        if (right < size && this._compare(right, largest) >= 0) {
            largest = right;
        }

        if (largest === current) break;

        this._swap(largest, current);
        current = largest;
    }
    //let b = this._elements.length
    //console.log("deq after: " + b)
    return first;
};

PriorityQueue.prototype.enq = function(element) {
    //let a = this._elements.length
    //console.log("enq before: " + a)
    var size = this._elements.push(element);
    var current = size - 1;

    while (current > 0) {
        var parent = Math.floor((current - 1) / 2);
        if (this._compare(current, parent) <= 0) break;
        this._swap(parent, current);
        current = parent;
    }
   //let b = this._elements.length
   //console.log("enq after: " + b)
    return size;
};

PriorityQueue.prototype.size = function() {
    return this._elements.length;
};

PriorityQueue.prototype.forEach = function(fn) {
    return this._elements.forEach(fn);
};

PriorityQueue.prototype._compare = function(a, b) {
    return this._d[this._elements[b]].score - this._d[this._elements[a]].score;
};

PriorityQueue.prototype._swap = function(a, b) {
    var aux = this._elements[a];
    this._d[this._elements[a]].pid = b;
    this._d[this._elements[b]].pid = a;
    this._elements[a] = this._elements[b];
    this._elements[b] = aux;
};